module.exports = __webpack_public_path__ + "static/media/rp01.3bf740bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/RilskaPrepravka/assets/rp01.jpg
// module id = 207
// module chunks = 0